module.exports = __webpack_public_path__ + "static/media/banner.1f4f9acd.png";